/** sessionStorage: đã hiển thị nhắc thông báo chưa đọc (desktop) trong phiên hiện tại */
export const DESKTOP_UNREAD_REMINDER_KEY = "ima_desktop_unread_reminder_done";
